import React from "react";

const HeroImage = ({
  backgroundImage,
  altText,
  heading,
  text,
  buttontext,
  buttonlink,
}) => {
  return (
    <div className="relative h-[600px] md:h-[600px] lg:h-[600px] overflow-hidden">
      {/* Background Video */}
      <img
        src={backgroundImage}
        alt={altText}
        className="background-image absolute inset-0 w-full h-[600px] object-cover"
      />
      <div className="absolute inset-0 bg-[#000] bg-opacity-20"></div>
      {/* Content */}
      <div className="absolute inset-0 flex items-center justify-center text-center">
        <div className="text-white p-6 max-w-6xl">
          {/* Heading */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 leading-tight">
            {heading}
          </h1>

          {/* Text */}
          <p className="text-base sm:text-lg md:text-xl leading-relaxed mb-6 sm:mb-8">
            {text}
          </p>

          {/* Optional Button */}
          {buttontext && (
            <a
              href={buttonlink}
              className="relative overflow-hidden py-4 px-8 rounded-md bg-[#BD0E0E] hover:bg-[#fff] text-white hover:text-black border-none cursor-pointer group"
            >
              {buttontext}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroImage;
